import { normalizeDate } from "@shared-domain/survey/date";

// UniQ デザイントークン (Claude Design: assets/unizo-tokens + UniQ 画面から)。
export const T = {
  accent: "#3DAEA3", // Unizo teal（UI 共通アクセント）
  ink: "#1B2A3A", // 濃いテキスト
  sub: "#64748B", // サブテキスト
  faint: "#94A3B8", // 補助テキスト
  line: "#EEF2F7", // 区切り
  bg: "#F3F6FB", // ページ背景 (回答一覧カード領域も同色の薄灰)
  card: "#FFFFFF",
  ok: "#3DAEA3", // 成功/実施済トーン (プライマリ=accent と同一値に統一・緑2色混在の解消)
  warn: "#D97706",
  danger: "#E0556B",
} as const;

export const hexA = (hex: string, a: number): string => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
};

// JST の「今日」(YYYY/MM/DD)。日付設問の既定値・「今日/昨日」ショートカットで使う。
const dateFmt = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric", month: "2-digit", day: "2-digit",
});
export const todayJst = (): string => dateFmt.format(new Date());
export const daysAgoJst = (n: number): string => dateFmt.format(new Date(Date.now() - n * 86400000));

/** 保存形式 (YYYY/MM/DD) → <input type="date"> の value (YYYY-MM-DD)。不正値は空。 */
export const toDateInput = (v: string): string =>
  (normalizeDate(v) ?? "").replace(/\//g, "-");
/** <input type="date"> の value (YYYY-MM-DD) → 保存形式 (YYYY/MM/DD)。 */
export const fromDateInput = (v: string): string => v.replace(/-/g, "/");

// ISO 日時 → JST "YYYY/MM/DD HH:MM" (回答日時などの表示用)。パース不能時は素の slice。
const stampFmt = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", hourCycle: "h23",
});
export const fmtStamp = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()))
    return iso.slice(0, 16).replace("T", " ").replace(/-/g, "/");
  const parts = stampFmt.formatToParts(d);
  const g = (t: string): string => parts.find((p) => p.type === t)?.value ?? "";
  return `${g("year")}/${g("month")}/${g("day")} ${g("hour")}:${g("minute")}`;
};
